// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1MotF","column":"style_column__3r77j","row":"style_row__68ZvZ"};